<template>
    <div class="invalid-feedback d-block" role="alert">
        <slot/>
    </div>
</template>

<script>
export default {
    name: "FormError"
}
</script>

<style scoped>

</style>
